import { connect } from 'react-redux';
import { get } from 'lodash';
import { actions as notification } from '@skunexus/notification';
import { ImportModal, Spinner } from '@skunexus/component-catalog';
import { api as apiGrid } from '@skunexus/grid';
import { useProductImport } from '../hooks/useProductImport';
import { useWarehousesDictionary } from '../hooks/useWarehousesDictionary';
import { useImprovedExport } from '../hooks/useImprovedExport';
import { useRepushProducts } from '../hooks/useRepushProducts';
import * as API from '../api';
import RepushProductsModal from '../components/RepushProductsModal';

const { Grid: GridApi } = apiGrid;

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    errorNotification: notification.error,
    successNotification: notification.success,
};

export const withCustomProductGridHoc = () => (Component) => {
    function WrappedComponent(props) {
        const { errorNotification, successNotification } = props;

        const [{ repushProductsModalProps }, { handleOpenRepushProductsModal }] = useRepushProducts({
            mutation: API.repushProducts,
            errorNotification,
            successNotification,
        });
        const [{ importModalProps }, { handleOpenImportModal }] = useProductImport({
            mutation: API.importProducts,
            errorNotification,
            successNotification,
        });

        const [{ isFetching, dictionary }] = useWarehousesDictionary({
            query: API.fetchDictionaries,
            errorNotification,
        });

        const { isLoading, handleExportAll, handleExportAllWithCurrentCols } = useImprovedExport({
            exportApi: API.exportData,
            exportConfig: GridApi.Export.config('product', 'products.csv')
                // .setCustomProcessPayload(customExportConfig)
                .get(),
            successNotification,
            errorNotification,
        });

        const customGridData = (gridProps) => {
            return {
                ...gridProps,
                filters: [
                    ...(gridProps.filters || []),
                    {
                        field: 'warehouse_key',
                        label: 'Warehouse',
                        type: 'select',
                        options: [{ value: '', label: 'All' }, ...get(dictionary, 'warehouse.grid.rows', [])],
                    },
                ],
                columns: [
                    ...(gridProps.columns || []).map((column) => {
                        if (column?.field === 'sku') {
                            return {
                                ...column,
                                asyncFilterField: 'sku_list',
                                type: 'tags',
                            };
                        }

                        return column;
                    }),
                ],
                config: {
                    ...(gridProps.config || {}),
                    multiActionsOptions: [
                        ...(gridProps.config?.multiActionsOptions || []),
                        {
                            id: 'import',
                            label: 'Import',
                            minItems: 0,
                            handler: handleOpenImportModal,
                        },
                        {
                            id: 'repush-products',
                            label: 'Repush Products',
                            minItems: 1,
                            handler: handleOpenRepushProductsModal,
                        },
                    ],
                    isLoading: gridProps.config?.isLoading || isLoading,
                    exportConfig: {
                        ...(gridProps.config?.exportConfig || {}),
                        handleExportAll,
                        handleExportAllWithCurrentCols,
                    },
                },
            };
        };

        if (isFetching) {
            return <Spinner />;
        }
        return (
            <>
                <Component {...props} customGridData={customGridData} />
                <ImportModal {...importModalProps} />
                <RepushProductsModal {...repushProductsModalProps} />
            </>
        );
    }

    return connect(mapStateToProps, mapDispatchToProps)(WrappedComponent);
};
